"use client";

import { Form } from "antd";
import { useEffect } from "react";

import { ATTRIBUTE_TYPE } from "~/core/constants/attributes";

import { useOpportunityAttributesDataByPipelineId } from "~/lib/opportunity-attributes/hooks/use-opportunity-attributes-databy-pipeline-id";

import { CORE_FIELDS, EXCLUDABLE_FIELDS } from "../constants";
import { useGlobalCreateOpportunityStore } from "../store";
import { checkFormHasValueWithoutPrePopulatedFields } from "../utils";

export const useGlobalNewOpportunityModal = () => {
  const [form] = Form.useForm();
  const setIsConfirmCloseForm = useGlobalCreateOpportunityStore(
    state => state.setIsConfirmCloseForm,
  );
  const setIsOpenGlobalCreateOpportunity = useGlobalCreateOpportunityStore(
    state => state.setIsOpenGlobalCreateOpportunity,
  );
  const setIsSaveAndNewMode = useGlobalCreateOpportunityStore(
    state => state.setIsSaveAndNewMode,
  );

  const setOpportunityAttributes = useGlobalCreateOpportunityStore(
    state => state.setOpportunityAttributes,
  );
  const setSelectTypeAttributes = useGlobalCreateOpportunityStore(
    state => state.setSelectTypeAttributes,
  );

  const resetSelection = useGlobalCreateOpportunityStore(
    state => state.resetSelection,
  );
  const resetActiveStateOfSelectTypeAttributes =
    useGlobalCreateOpportunityStore(
      state => state.resetActiveStateOfSelectTypeAttributes,
    );

  const selectedPipelineId = useGlobalCreateOpportunityStore(
    state => state.selectedPipeline?.value,
  );

  const { opportunityAttributes } = useOpportunityAttributesDataByPipelineId({
    pipeline_id: selectedPipelineId as string,
    enabled: !!selectedPipelineId,
  });

  useEffect(() => {
    if (opportunityAttributes) {
      const filteredFields = opportunityAttributes.filter(
        (field: any) =>
          ![...EXCLUDABLE_FIELDS, ...CORE_FIELDS].includes(field.property_name),
      );

      setOpportunityAttributes(filteredFields);
      setSelectTypeAttributes(
        filteredFields
          .filter(
            field =>
              field.attribute_type === ATTRIBUTE_TYPE.SELECT ||
              field.attribute_type === ATTRIBUTE_TYPE.MULTI_SELECT,
          )
          .map(field => ({
            ...field,
            options:
              field.metadata?.select_options
                ?.sort((a, b) => a.order - b.order)
                .map(option => ({
                  label: option.label,
                  id: option.value,
                  searchableText: option.label,
                  metadata: {
                    ...field.metadata,
                    select_options: option,
                  },
                })) ?? [],
          })),
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [opportunityAttributes]);

  const handleCancel = () => {
    const hasValue = checkFormHasValueWithoutPrePopulatedFields(form);
    if (!!hasValue) {
      setIsConfirmCloseForm(true);
    } else {
      setIsOpenGlobalCreateOpportunity(false);
      setIsSaveAndNewMode(false);

      resetSelection();
      resetActiveStateOfSelectTypeAttributes();
      form.resetFields();
    }
  };

  const handleClose = () => {
    setIsConfirmCloseForm(false);
    setIsOpenGlobalCreateOpportunity(false);
    setIsSaveAndNewMode(false);

    resetSelection();
    resetActiveStateOfSelectTypeAttributes();
    form.resetFields();
  };

  return { form, handleCancel, handleClose };
};
